import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { Box, IconButton, Menu, useTheme } from '@mui/material';

interface HamburgerMenuProps {
  children?: React.ReactNode;
}

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({ children }) => {
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <IconButton
        onClick={handleClick}
        sx={{ marginLeft: 'auto' }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            border: '1px solid ' + theme.palette.grey[500],
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
          }}
        >
          <MenuIcon htmlColor={theme.palette.grey[500]} />
        </Box>
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
      >
        {React.Children.map(children, (child) =>
          React.isValidElement(child)
            ? // @ts-expect-error: Override the type error
              React.cloneElement(child, { onClose: handleClose })
            : child,
        )}
      </Menu>
    </React.Fragment>
  );
};

export default HamburgerMenu;
